// extracted by mini-css-extract-plugin
export var errorsContainer = "_rc-1";
export var link = "_rc-0";